import React from 'react';
import { Loader } from 'emerald-ui/dist/Loader';

/** @type {React.FC<{}>} */
export const Loading = () => {
    return (
        <Loader style={{ height: '100%' }} />
    );
};
